export { default as DCRow } from './components/dc-row';
export { default as DCCol } from './components/dc-col';
const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
